import { Outlet } from 'react-router-dom';
import { useBackAction } from '@/shared/hooks/useBackAction';
import { useMaxBackButton } from '@/shared/hooks/useMaxBackButton';
import { useSwipeBack } from '@/shared/hooks/useSwipeBack';
import { getAppMode } from '@/shared/utils';
import styles from './App.module.less';

export function AppWithoutNav() {
  const onBack = useBackAction();

  useSwipeBack(onBack, getAppMode() === 'max');
  useMaxBackButton();

  return (
    <div className={styles.app}>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
